import "./App.css";
import Home from "./Frontend/pages/Home";
function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
